import { z } from "zod";

const validNameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.(com|com\.br|br)$/i;

export const editUserSchema = z.object({
	name: z
		.string()
		.min(3, "O nome deve ter pelo menos 3 caracteres")
		.max(50, "O nome não pode ter mais que 50 caracteres")
		.regex(validNameRegex, "O nome deve conter apenas letras e espaços"),

	email: z
		.string()
		.min(5, "E-mail muito curto")
		.max(254, "E-mail muito longo")
		.email("E-mail inválido")
		.regex(emailRegex, "O e-mail deve terminar com .com, .com.br ou .br"),

	group_ids: z.array(z.number()).optional(),
});

export type EditUserFormValues = z.infer<typeof editUserSchema>;
